import { paramCase } from 'change-case';
import { v4 as generateUuid } from 'uuid';

const createKey = (...params: Array<string | number>): string => ['x', ...params].map((param) => paramCase(`${param}`)).join('-');

const generateUnique = (): string => `x${generateUuid().replace(/[^\d\w]/gm, '')}`;

export { createKey, generateUnique };
